if (!window.Eurus.loadedScript.has('preview-color-swatches.js')) {
  window.Eurus.loadedScript.add('preview-color-swatches.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductCard', (
        sectionId,
        productUrl,
        productId,
      ) => ({
        isSelect: false,
        productId: productId,
        showOptions: false,
        init() {
          document.addEventListener(`eurus:product-card-variant-select:updated:${sectionId}:${productUrl}`, (e) => {
            this.checkVariantSelected();
          });
        },
        checkVariantSelected() {
          const fieldset = [...document.querySelectorAll(`#variant-update-${sectionId} fieldset`)];
          if(fieldset.findIndex(item => !item.querySelector("input:checked")) == "-1") {
            this.isSelect = true;
          }
        }
      }));
    })
  });
}

/* LIORA TEST — TressAllure virtual large color preview.
   Keeps swatch assets out of Shopify product/variant media while preserving
   the shopper experience of clicking a small swatch to view it large. */
(() => {
  if (window.__lioraTressAllureVirtualPreviewLoaded) return;
  window.__lioraTressAllureVirtualPreviewLoaded = true;

  const isTressAllurePicker = (picker) =>
    Boolean(picker?.querySelector('.liora-tressallure-variants'));

  const fullSizeSwatchUrl = (url) => String(url || '')
    .replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|master|\d+x\d+)(?=\.(?:avif|gif|jpe?g|png|webp))/i, '')
    .replace(/([?&])(width|height)=\d+/gi, '$1')
    .replace(/\?&/g, '?')
    .replace(/&&+/g, '&')
    .replace(/[?&]$/, '');

  const swatchUrlFromLabel = (label) => {
    if (!label) return '';
    let background = window.getComputedStyle(label, '::before').backgroundImage;
    if (!background || background === 'none') {
      background = window.getComputedStyle(label).backgroundImage;
    }
    const match = background?.match(/^url\(["']?(.*?)["']?\)$/i);
    return match?.[1] ? fullSizeSwatchUrl(match[1]) : '';
  };

  const clearVirtualSwatches = (section = document) => {
    section.querySelectorAll('[data-liora-virtual-swatch]').forEach((image) => image.remove());
  };

  const showVirtualSwatch = (picker, label, color) => {
    const url = swatchUrlFromLabel(label);
    if (!url) return;

    const section = picker?.closest('[id^="shopify-section-"]') || document;
    const activeSlide = section.querySelector('.splide__slide.is-active[data-media-id]')
      || section.querySelector('[data-media-id].is-active')
      || section.querySelector('.media-slide[data-media-id]')
      || section.querySelector('[aria-label="zoom-image"][data-media-id]');
    const frame = activeSlide?.querySelector('button, [aria-label="zoom-image"]') || activeSlide;
    if (!frame) return;

    clearVirtualSwatches(section);
    const image = document.createElement('img');
    image.src = url;
    image.alt = `${color || 'Selected'} color swatch`;
    image.dataset.lioraVirtualSwatch = 'true';
    image.className = 'liora-virtual-gallery-swatch';
    image.decoding = 'async';
    image.style.position = 'absolute';
    image.style.inset = '0';
    image.style.width = '100%';
    image.style.height = '100%';
    image.style.objectFit = 'contain';
    image.style.background = 'rgb(var(--background-color, 255, 255, 255))';
    image.style.zIndex = '4';
    image.style.pointerEvents = 'none';

    if (window.getComputedStyle(frame).position === 'static') {
      frame.style.position = 'relative';
    }
    frame.appendChild(image);
  };

  const selectedSwatch = (picker) => {
    const input = picker?.querySelector('input[type="radio"]:checked');
    const label = input?.id
      ? document.querySelector(`label[for="${CSS.escape(input.id)}"]`)
      : null;
    return { input, label, color: input?.value || '' };
  };

  const scheduleSelectedPreview = (picker, delay = 340) => {
    window.setTimeout(() => {
      const { input, label, color } = selectedSwatch(picker);
      if (!input || input.dataset.available === 'false') return;
      showVirtualSwatch(picker, label, color);
    }, delay);
  };

  document.addEventListener('eurus:variant:change', (event) => {
    const picker = event.target?.closest?.('.x-variant-picker')
      || document.querySelector('.x-variant-picker');
    if (!isTressAllurePicker(picker)) return;
    scheduleSelectedPreview(picker, 360);
  });

  document.addEventListener('click', (event) => {
    const label = event.target?.closest?.('label[for]');
    if (!label) return;

    const input = document.getElementById(label.htmlFor);
    const picker = input?.closest?.('.x-variant-picker');
    if (!isTressAllurePicker(picker) || input?.dataset.available === 'false') return;

    window.setTimeout(() => showVirtualSwatch(picker, label, input.value), 380);
  });
})();
